import React from "react";
import { observer } from "mobx-react";
import SubscriptionCreatePage from "~/modules/BillingCentral/app/SubscriptionCreatePage";
import "../styles/SidePage.less";

const ClientPanelSubscriptionCreatePage = observer(props => <SubscriptionCreatePage {...props} />);

export default ClientPanelSubscriptionCreatePage;
